import { render, staticRenderFns } from "./EnrolmentQuestionViewer.vue?vue&type=template&id=960da968&scoped=true"
import script from "./EnrolmentQuestionViewer.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionViewer.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentQuestionViewer.vue?vue&type=style&index=0&id=960da968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960da968",
  null
  
)

export default component.exports